import { styled } from '@vw-marketing/us-components';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  gap: ${({ theme }) => theme.size.static350};
  box-sizing: border-box;
  ${({ theme }: { theme: VWTheme }) => {
    return `
      gap: ${theme.size.static350};
      margin-top: ${theme.size.static400};
    `;
  }}
`;

export const StyledVerificationCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  ${({ theme }: { theme: VWTheme }) => {
    return `
      gap: ${theme.size.static350};
      margin-top: ${theme.size.static400};
    `;
  }}
`;

export const StyledInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & [class^='StyledDisplayTag-'],
  & [class*=' StyledDisplayTag-'] {
    & [class^='StyledTextComponent-'],
    & [class*=' StyledTextComponent-'] {
      display: block;
    }
  }
  & [class^='StyledCharacterCounter-'],
  & [class*=' StyledCharacterCounter-'] {
    display: none;
  }
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.size.static400};
`;

export const InfoboxContainer = styled.div`
  display: flex;

  & [class^='StyledInfobox-'],
  & [class*=' StyledInfobox-'] {
    width: 100% !important;
    box-sizing: border-box;
  }
`;
